// extracted by mini-css-extract-plugin
export default {"knowledge":"Knowledge_knowledge__ChhCY","knowledge_desc":"Knowledge_knowledge_desc__4P68k","knowledge_button":"Knowledge_knowledge_button__npvsz"};